import {
  EditMFAConfig,
  MFAConfig,
  MFAConfigGenerateBackupCodes,
  MFAResponseSendOTP,
  MFAResponseVerifyBackupCode,
  MFAResponseVerifyOTP,
  MFASendOTP,
  MFATrustedDeviceParams,
  MFAVerifyBackupCode,
  MFAVerifyOTP,
  WithPaginationMFATrustedDevice
} from "@organization/models"
import { ssoAxios } from "./axios"
import { createQueryKeys } from "@lukemorales/query-key-factory"

const _getMFAHeaders = (mfaAccessToken: string) => ({ Authorization: `Token ${mfaAccessToken}` })

const _getMFAConfig = (mfaAccessToken: string) => ({
  headers: _getMFAHeaders(mfaAccessToken),
  skipAuthHeader: true  
})

export const mfa = {
  getConfig: async () => {
    const { data } = await ssoAxios.get<MFAConfig>('/mfa/config/')

    return data
  },

  putConfig: async (body: EditMFAConfig) => {
    const { data } = await ssoAxios.put<MFAConfig>('/mfa/config/', body)

    return data
  },

  patchConfig: async (body: EditMFAConfig) => {
    const { data } = await ssoAxios.patch<MFAConfig>('/mfa/config/', body)

    return data
  },

  downloadBackupCodes: async () => {
    const { data } = await ssoAxios.post<Blob>('/mfa/config/download-backup-codes/', undefined, { responseType: 'blob' })

    return data
  },

  generateBackupCodes: async () => {
    const { data } = await ssoAxios.post<MFAConfigGenerateBackupCodes>('/mfa/config/generate-backup-codes/')

    return data
  },

  sendOtp: async ({ __mfaAccessToken, ...body }: MFASendOTP) => {
    const { data } = await ssoAxios.post<MFAResponseSendOTP>('/mfa/send-otp/', body, _getMFAConfig(__mfaAccessToken))

    return data
  },

  verifyOtp: async ({ __mfaAccessToken, ...body }: MFAVerifyOTP) => {
    const { data } = await ssoAxios.post<MFAResponseVerifyOTP>('/mfa/verify-otp/', body, _getMFAConfig(__mfaAccessToken))

    return data
  },

  verifyBackupCode: async ({ __mfaAccessToken, ...body }: MFAVerifyBackupCode) => {
    const { data } = await ssoAxios.post<MFAResponseVerifyBackupCode>('/mfa/verify-backup-code/', body, _getMFAConfig(__mfaAccessToken))

    return data
  },

  getTrustedDevices: async (params?: MFATrustedDeviceParams) => {
    const { data } = await ssoAxios.get<WithPaginationMFATrustedDevice>('/mfa/trusted-devices/', { params })

    return data
  },

  deleteTrustedDevice: async (id: string) => {
    const { data } = await ssoAxios.delete<void>(`/mfa/trusted-devices/${id}/`)

    return data
  },

  deleteAllTrustedDevices: async ({deviceToken}: {deviceToken?: string}) => {
    
    const { data } = await ssoAxios.delete<void>('/mfa/trusted-devices/delete-all/',{
      ...(deviceToken && { headers:{
        "Device-Token": deviceToken
      }}),
    })

    return data
  },
}

export const mfaQuery = createQueryKeys('mfa', {
  getConfig: () => ({
    queryKey: ['config'],
    queryFn: () => mfa.getConfig()
  }),

  getTrustedDevices: (params?: MFATrustedDeviceParams) => ({
    queryKey: ['trusted-devices', params],
    queryFn: () => mfa.getTrustedDevices(params)
  })
})